import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            We offer an array of services spanning multiple practice areas, including space acquisition and disposition as well as strategic consulting services across all market sectors.
          </h3>
          <p>
            With professionals focused on the office sector than any other firm globally, Kinos Office Services delivers innovative corporate real estate solutions to suit the specific needs of both occupiers/tenants and owners/investors.



Fortified with industry-leading econometric forecasting, proprietary databases, and full-service research and marketing capabilities, our professionals collaborate across geographic borders and service lines to offer significant value to our clients. And powered by Kinos global technology platform ( Torus Network ) that connects our world-class advisors in all corners of the world, we provide real-time local-market insight and experience that delivers strong outcomes for occupiers that operate on a local, national or global level.


          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured={featured} url="office" />
          <SectionRecents recents={recents} url="office" />
        </GridItem>

        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
